module.exports = __webpack_public_path__ + "img/search-results.51820348.png";